import styles from './Input.module.css';
import type InputProperties from './Input.properties.ts';
import { type CSSProperties, forwardRef, type Ref } from 'react';

const InputView = forwardRef<HTMLInputElement, InputProperties>(
  (props: InputProperties, ref: Ref<HTMLInputElement>) => {
    return (
      <input
        ref={ref}
        className={`${styles.input} ${props.className ?? ''}`}
        placeholder={props.placeholder}
        value={props.value}
        onChange={props.onChange}
        type={props.type ?? 'text'}
        min={props.min}
        max={props.max}
        disabled={props.disabled}
        style={
          {
            '--width': props.width ?? 140,
          } as CSSProperties
        }
      />
    );
  }
);

export default InputView;
